import { Language } from '@configs/language';

const BASE_LANGUAGE_LABELS = {
  lgnWelcomeEfex: 'Welcome to EFEX',
  lngWelcomeWhiteLabel: 'Welcome',
  lngPasswordForgot: 'Forgot your password?',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const LOGIN_LABELS: Record<Language, Record<LabelsLanguage, string>> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    lgnWelcomeEfex: 'Bienvenido a EFEX',
    lngWelcomeWhiteLabel: 'Bienvenido',
    lngPasswordForgot: '¿Olvidaste tu contraseña?',
  },
};

export default LOGIN_LABELS;
